import "./our-media.scss";
import HeadlineSection from "../../components/headline-section";
import CustomButton from "../../components/custom-button";
import MediaCard from "../media-card";
import { Link } from "react-router-dom";
import media1 from "../../assets/home/media1.jpg";
import media2 from "../../assets/home/media2.jpg";
import media3 from "../../assets/home/media3.jpg";
import media4 from "../../assets/home/media4.jpg";



const OurMedia = () => {
  return (
      <div className="our-media">
        <div>
          <HeadlineSection headline="المركز" secondHeadline="الإعلامي" />
          <p className="description-title">حديث الصورة... إنجاز بإيجاز</p>
        </div>
        
        <div className="all-media">

            <MediaCard mediaImage={media1}
            mediaTitle={"تقرير عام 1440"}/>
            <MediaCard mediaImage={media2}
            mediaTitle={"تقرير عام 1441"}/>
            <MediaCard mediaImage={media3}
            mediaTitle={"تقرير عام 1436"}/>
            <MediaCard mediaImage={media4}
            mediaTitle={"تقرير عام 1435"}/>

        </div>
         
        <div>
         <Link to={"/media"} target="_blank">
              <CustomButton classes="shawi-more-btn" title="المزيد" /> 
          </Link>

        </div>
      </div>
  );
};

export default OurMedia;